import { makeObservable, observable } from 'mobx';
import { Component } from './Component';

/*
 * This class is used to store the state of a search result record.
 */
type TSearchResultState = {
  title: string;
  body: string;
  link: string;
};

export class SemanticSearchReference {
  state: TSearchResultState = { title: '', body: '', link: '' };

  public constructor(props: TSearchResultState) {
    this.state = props;
    makeObservable(this, { state: observable });
  }

  Component = () => (
    <>
      (<Component instance={this} />)
    </>
  );
}
